export const getCandidateVideoMp4 = videoSrc => {
  if (!videoSrc) return "";

  const extention = videoSrc.split(".").pop();
  const mp4Url = videoSrc.replace(extention, "mp4");

  return getOptimizedUrl(mp4Url);
};

export const getCandidateVideoThumbnail = videoSrc => {
  if (!videoSrc) return;

  const extention = videoSrc.split(".").pop();

  const watermark = "c_scale,w_380/so_0,f_auto,q_auto:low/c_crop,w_380,h_380";
  return (
    videoSrc
      // https://regex101.com/r/Uhzqfd/1/
      .replace(/upload(\/.+crop|)/, `upload/${watermark}`)
      .replace(extention, "jpg")
      .replace("http:", "https:")
  );
};

export const getCandidateBlurryBackground = videoSrc => {
  if (!videoSrc) return;

  const extention = videoSrc.split(".").pop();

  const watermark = "c_scale,h_380,e_blur:2000/so_0,f_auto,q_auto:low";
  return videoSrc
    .replace("upload", `upload/${watermark}`)
    .replace(extention, "jpg")
    .replace("http:", "https:");
};

export const getOptimizedUrl = url => {
  if (!url) {
    return;
  }

  if (url.match("worcket")) {
    return url;
  }

  return url
    .replace("video/upload", "video/upload/so_0,q_auto:low")
    .replace("http:", "https:");
};
